import React, {Component} from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretLeft, faCaretRight, faCaretUp, faPlay, faCaretDown} from '@fortawesome/free-solid-svg-icons';

import {ModalTrigger} from 'Components/Modal';
import UpdateCarouselItem from './UpdateCarouselItem';

export default class Carousel extends Component {
    /**
     * INSTRUCTIONS
     *
     * In your tailwind.config.js please make sure you add a purge exception `grid-cols-x` where X is the number
     * per page you have selected.
     * E.g. https://github.com/DualityStudio/homeinstead/blob/develop/resources/tailwind.config.js.
     *
     * Failure to do so, means this will not work when the assets are compiled to
     * production as we set the x dynamically and therefore tailwind will purge this class from the production mix.
     */

    /**
     * @var state
     * @type {{per_page, start: number, thumbnail_height}}
     */
    state = {
        per_page: this.props.perPage ?? 4,
        thumbnail_height: this.props.thumbnailHeight ?? 120,
        start: 0,
    };

    /**
     * @method previous
     */
    previous = () => {
        const {per_page, start} = this.state;
        const {items} = this.props;

        let new_start = +start - +per_page;

        if (new_start < 0) {
            new_start = (Math.floor((items.length / per_page)) * per_page) - per_page;
        }

        this.setState({
            start: new_start
        });
    };

    /**
     * @method next
     */
    next = () => {
        const {per_page, start} = this.state;
        const {items} = this.props;

        let new_start = +start + +per_page;

        if (new_start >= items.length) {
            new_start = 0;
        }

        this.setState({
            start: new_start
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {items, arrowColour} = this.props;
        const {start, per_page} = this.state;

        return (
            <div className="relative py-10 md:py-6 md:px-5">
                {items.length > per_page && (
                    <div
                        className={`
                            absolute left-0 top-0 right-0 md:right-auto md:bottom-0 flex justify-center select-none 
                            justify-center md:items-center cursor-pointer transform transition duration-200 hover:scale-110 
                            ${arrowColour ? arrowColour : 'text-red-500'}
                        `}
                        onClick={() => this.previous()}
                    >
                        <FontAwesomeIcon icon={faCaretLeft} size="3x" className="hidden sm:flex"/>
                        <FontAwesomeIcon icon={faCaretUp} size="3x" className="sm:hidden"/>
                    </div>
                )}

                <div className={`md:grid grid-cols-${per_page}`}>
                    {items
                        .filter((item, i) => (i >= start && i < (+start + +per_page)))
                        .map((item, i) => {
                            return (
                                this.renderCarouselItem(item, i)
                            )
                        })}
                </div>

                {items.length > per_page && (
                    <div
                        className={`
                            absolute left-0 md:left-auto right-0 md:top-0 bottom-0 flex justify-center select-none 
                            items-center cursor-pointer transform transition duration-200 hover:scale-110 
                            ${arrowColour ? arrowColour : 'pink'}
                        `}
                        onClick={() => this.next()}
                    >
                        <FontAwesomeIcon icon={faCaretRight} size="3x" className="hidden sm:flex"/>
                        <FontAwesomeIcon icon={faCaretDown} size="3x" className="sm:hidden"/>
                    </div>
                )}
            </div>
        );
    }

    /**
     * @method renderCarouselItem
     * @param {object} item
     * @param {number} i
     * @return {JSX.Element}
     */
    renderCarouselItem = (item, i) => {
        const {editor, exhibitor, editorSubmitCallback} = this.props;

        if (editor) {
            return (
                <ModalTrigger 
                    component={UpdateCarouselItem}
                    disabled={!editor}
                    props={{
                        exhibitor: exhibitor,
                        carouselItem: item,
                        submitCallback: editorSubmitCallback
                    }}
                >
                    {this.renderCarouselItem2(item)}
                </ModalTrigger>
            );
        }

        return (
            <a className="md:px-4" href={item.src} target="_blank">
                {this.renderCarouselItem2(item)}
            </a>
        );
    };

    /**
     * @method renderCarouselItem2
     * @param {object} item
     * @return {JSX.Element}
     */
    renderCarouselItem2 = (item) => {
        const {thumbnail_height} = this.state;

        return (
            <>
                {item.thumbnail && (
                    <div style={{
                        backgroundImage: 'url("' + item.thumbnail.url + '")',
                        height: thumbnail_height + 'px',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                    }} />
                )}

                {!item.thumbnail && (
                    <div className="border border-gray-300 card rounded-sm flex items-center justify-center"
                        style={{
                            height: '120px',
                            backgroundSize: '30px',
                            backgroundImage: "url('/assets/play.png')"
                        }}>
                        <FontAwesomeIcon icon={faPlay} />
                    </div>
                )}

                <p className="bold mt-2 text-center ">
                    {item.title}
                </p>

                {item.subtitle && (
                    <p>
                        {item.subtitle}
                    </p>
                )}
            </>
        );
    }
}
